var _rect, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "url(#paint0_linear_14823_29530)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9429 16.6849L11.8858 18.7419C11.5071 19.1206 11.5071 19.7346 11.8858 20.1133C12.2645 20.492 12.8785 20.492 13.2572 20.1133L15.3142 18.0562L15.9999 18.7419C16.7573 19.4993 16.7573 20.7273 15.9999 21.4846L13.2572 24.2274C12.4998 24.9847 11.2718 24.9847 10.5145 24.2274L7.77175 21.4846C7.01437 20.7273 7.01437 19.4993 7.77175 18.7419L10.5145 15.9992C11.2718 15.2418 12.4998 15.2418 13.2572 15.9992L13.9429 16.6849Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0563 15.3141L20.1134 13.2571C20.4921 12.8784 20.4921 12.2644 20.1134 11.8857C19.7347 11.5071 19.1207 11.5071 18.742 11.8857L16.685 13.9428L15.9993 13.2571C15.2419 12.4997 15.2419 11.2718 15.9993 10.5144L18.742 7.77167C19.4994 7.01429 20.7273 7.01429 21.4847 7.77167L24.2274 10.5144C24.9848 11.2718 24.9848 12.4997 24.2274 13.2571L21.4847 15.9998C20.7273 16.7572 19.4994 16.7572 18.742 15.9998L18.0563 15.3141Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45701 8.45705C8.8357 8.07836 9.44968 8.07836 9.82837 8.45705L11.1997 9.82841C11.5784 10.2071 11.5784 10.8211 11.1997 11.1998C10.821 11.5785 10.2071 11.5785 9.82837 11.1998L8.45701 9.82841C8.07832 9.44972 8.07832 8.83574 8.45701 8.45705ZM13.4231 5.83198C13.9587 5.83198 14.3928 6.26613 14.3928 6.80168L14.3928 8.74107C14.3928 9.27662 13.9587 9.71077 13.4231 9.71077C12.8876 9.71077 12.4534 9.27662 12.4534 8.74107L12.4534 6.80167C12.4534 6.26613 12.8876 5.83198 13.4231 5.83198ZM5.99831 13.2568C5.99831 12.7213 6.43246 12.2871 6.96801 12.2871L8.9074 12.2871C9.44295 12.2871 9.8771 12.7213 9.8771 13.2568C9.8771 13.7924 9.44295 14.2265 8.9074 14.2265L6.96801 14.2265C6.43246 14.2265 5.99831 13.7924 5.99831 13.2568Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4248 23.4248C23.8035 23.0461 23.8035 22.4322 23.4248 22.0535L22.0534 20.6821C21.6747 20.3034 21.0608 20.3034 20.6821 20.6821C20.3034 21.0608 20.3034 21.6748 20.6821 22.0535L22.0534 23.4248C22.4321 23.8035 23.0461 23.8035 23.4248 23.4248ZM26.0499 18.4587C26.0499 17.9231 25.6157 17.489 25.0802 17.489L23.1408 17.489C22.6052 17.489 22.1711 17.9231 22.1711 18.4587C22.1711 18.9942 22.6052 19.4284 23.1408 19.4284L25.0802 19.4284C25.6157 19.4284 26.0499 18.9942 26.0499 18.4587ZM18.625 25.8835C19.1606 25.8835 19.5947 25.4494 19.5947 24.9138L19.5947 22.9744C19.5947 22.4389 19.1606 22.0047 18.625 22.0047C18.0895 22.0047 17.6553 22.4389 17.6553 22.9744L17.6553 24.9138C17.6553 25.4494 18.0895 25.8835 18.625 25.8835Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14823_29530",
    x1: 32,
    y1: 9.31104,
    x2: -1.61938,
    y2: 13.6949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22356C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212641"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.f77fb4abf9e21f89c803a074f9470dab.svg";
export { ForwardRef as ReactComponent };